import React from 'react'
import type {
  Control,
  ControllerRenderProps,
  FieldPath,
  FieldValues
} from 'react-hook-form'

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form'
import { cn } from '@/lib/utils'

export { Form } from '@/components/ui/form'

export interface IFormField {
  control: Control<any>
  name: string
  label?: string | React.ReactNode | undefined
  wrapperClassName?: string
  controlRender: ({
    field
  }: {
    field: ControllerRenderProps<FieldValues, FieldPath<FieldValues>>
  }) => React.ReactNode
}

export const FormValidField: React.FC<IFormField> = ({
  wrapperClassName,
  ...props
}) => {
  return (
    <FormField
      control={props.control}
      name={props.name}
      render={({ field }) => (
        <FormItem className={cn('relative space-y-2', wrapperClassName)}>
          {props.label !== undefined && (
            <FormLabel className="block font-Orbitron text-sm text-color-text-secondary xl:text-base">
              {props.label}
            </FormLabel>
          )}
          <FormControl>{props.controlRender({ field })}</FormControl>
          <FormMessage className="" />
        </FormItem>
      )}
    ></FormField>
  )
}
